import CardCommon from '@op/components/CardCommon';
import React, { useEffect } from 'react';
import { Col, Row } from 'tea-component';

import Events from './Events';
import RisingKeywords from './RisingKeywords';
import useLanguage from '@op/hooks/useLanguage';
import { formatTimeToShow } from '@op/utils/time';
import RisingTopics from '@op/pages/Summary/components/RisingTopics';

export default function NoticeableOpinions({
  filter,
  gameInfo,
  translateTopic,
}: any) {
  const { formatMessage } = useLanguage();

  return (
    <CardCommon
      title={formatMessage({ id: 'Opinions Highlights' })}
      subTitle={formatTimeToShow(filter)}
      className="dbo-noticeable-opinions-card"
    >
      <Row>
        <Col span={8}>
          <Events filter={filter} gameInfo={gameInfo} />
        </Col>
        <Col span={8}>
          <RisingTopics
            translateTopic={translateTopic}
            filter={filter}
            gameInfo={gameInfo}
          />
        </Col>
        <Col span={8}>
          <RisingKeywords filter={filter} gameInfo={gameInfo} />
        </Col>
      </Row>
    </CardCommon>
  );
}
